module.exports = __webpack_public_path__ + "490c50b0d14fa9dfb7992b95eff6a552.png";


//////////////////
// WEBPACK FOOTER
// ./Res/img/hausplanner_logo_gold.png
// module id = 3000
// module chunks = 1